export const PERMISSIONS = {
  VIEW_HOMEPAGE: 'VIEW_HOMEPAGE',
  MARK_ATTENDANCE: 'MARK_ATTENDANCE',
  VIEW_AMC_HOMEPAGE: 'VIEW_AMC_HOMEPAGE',
  VIEW_INVENTORY: 'VIEW_INVENTORY',
  RAISE_SERVICE_REQUEST: 'RAISE_SERVICE_REQUEST',
  VIEW_NARCOTICS: 'VIEW_NARCOTICS',
  VIEW_PENDING_APPROVALS: 'VIEW_PENDING_APPROVALS',
  VIEW_SHIFT_TRADE: 'VIEW_SHIFT_TRADE',
  MANAGE_SHIFT_TRADE: 'MANAGE_SHIFT_TRADE',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
